RivalIQ.apps.Favorites.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Widget = widgets.Builder = RivalIQ.apps.Dashboard.models.Widget.extend({
        view: App.views.Builder,
        title: 'Create a New Chart',

        exportFormats: [],
        hasViewMore: _.constant(false),

        processProps: function (props) {
            return _.defaults({
                widgetId: RivalIQ.enums.widgetTypes.METRIC_TABLE
            }, props);
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.BUILDER, Widget);

});
